// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kt-0";